/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Rollback_Of_LabelInputs */

const vi_note_rollback_of_label = /** @type {(inputs: Note_Rollback_Of_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu điều chỉnh rollback của phiếu`)
};

/**

* @param {Note_Rollback_Of_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_rollback_of_label = /** @type {((inputs?: Note_Rollback_Of_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Rollback_Of_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_rollback_of_label(inputs)
});